export default "__VITE_ASSET__46370f8b__"